
import {
	GET_ERRORS,
	FEATURED_PRODUCTS,
	GET_ALL_PRODUCTS,
	DEACTIVATE_FEATURED_PRODUCTS,
	UPDATE_FEATURED_PRODUCTS
} from "../actions/types";

const initialState = {
	deleteOk: false,
	alreadyImages: null,
	actionType: '',
	pendingImages: [],
	error: ''
};


export default function (state = initialState, action) {
	switch (action.type) {
		case FEATURED_PRODUCTS:
			return {
				...state,
				actionType: action.type,
				featuredProducts: action.payload
			}
		case DEACTIVATE_FEATURED_PRODUCTS:
			return {
				...state,
				actionType: action.type
			}
		case UPDATE_FEATURED_PRODUCTS:
			return {
				...state,
				actionType: action.type
			}
		case GET_ALL_PRODUCTS:
			return {
				...state,
				actionType: action.type,
				allProducts: action.payload
			};
		case GET_ERRORS:
			return {
				...state,
				actionType: action.type,
				error: action.payload,
				message: action.payload
			}
		default:
			return state;
	}
}
